module.exports = __webpack_public_path__ + "static/img/2.1.c6fbafa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/zh/2.1.png
// module id = 9Ef4
// module chunks = 0